var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorBanner',{attrs:{"is-open":_vm.isOpen,"position":_vm.position,"message":_vm.message,"show-icon":_vm.showIcon,"critical":_vm.critical,"action-label":_vm.actionLabel,"close-label":_vm.closeLabel},on:{"close":_vm.handleClose,"action":_vm.handleAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }